updateQueries